import {getField, updateField} from 'vuex-map-fields';
import BaseTableModule from '@/commonFunction/baseTableModule'

let mpnresearchBatch = new BaseTableModule('/ws/mpnresearch_batch/');

const state = {
    ...mpnresearchBatch.state,
    columns: [
        {text: 'Actions', value: 'actions', sortable: false, divider: true, brief: true,},
        {text: 'Name', value: 'name', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Description', value: 'description', sortable: true, divider: true, brief: true,},
        {text: 'Creator', value: 'creator__username', sortable: true, divider: true, brief: true,},
        {text: 'Modifier', value: 'modifier__username', sortable: true, divider: true, brief: true,},
        {text: 'Created', value: 'created', sortable: true, divider: true, brief: true,},
        {text: 'Modified', value: 'modified', sortable: true, divider: true, brief: true,},
    ],
    briefView: true,
    options: {
        page: 1,
        itemsPerPage: 20,
        sortBy: ['batch_size'],
        sortDesc: [false],
        multiSort: false,
        mustSort: true,
        descending: false,

    },
};
const getters = {
    ...mpnresearchBatch.getters,
    getColumns(state) {
        if (state.briefView) {
            return state.columns.filter(row => row.brief === true)
        } else {
            return state.columns
        }
    },
    getBatchSizeList(state) {
        return state.itemList.sort(function (a, b) {
            return a.batch_size - b.batch_size
        })
    },

    getBatchSizeNumberList(state) {
        let numberList = []
        for (const item of state.itemList)
            numberList.push(item.batch_size.toString())
        return numberList
    },
};
const actions = {
    ...mpnresearchBatch.actions,
};
const mutations = {
    ...mpnresearchBatch.mutations,
};

export default {
    modules: {
        MPNResearchBatch: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}